import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const Base_URL = `/tasks`;

export const getAllUserTasksApi = async (category) => {
  const res = await axiosInstance.get(`${Base_URL}/all`, {
    ...getAuthHeaders(),
    params: category ? { category } : {},
  });
  return res.data;
};

export const getTaskApi = async (taskId) => {
  const res = await axiosInstance.get(
    `${Base_URL}/${taskId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const createTaskForChannelApi = async (taskId, taskData) => {
  const res = await axiosInstance.post(
    `${Base_URL}/action/${taskId}`,
    taskData,
    getAuthHeaders(),
  );
  return res.data;
};

export const executeTaskApi = async (taskData) => {
  const res = await axiosInstance.post(
    `${Base_URL}/execute`,
    { taskData },
    getAuthHeaders(),
  );
  return res.data;
};

export const getTaskOptionsApi = async (settingId, platformType, taskId) => {
  const res = await axiosInstance.post(
    `${Base_URL}/options`,
    { settingId, platformType, taskId },
    getAuthHeaders(),
  );
  return res.data;
};

export const addTaskReplyAPI = async ({ taskId, actionId, reply }) => {
  const res = await axiosInstance.post(
    `${Base_URL}/messages/reply`,
    { taskUuid: taskId, actionUuid: actionId, message: reply },
    getAuthHeaders(),
  );
  return res.data;
};

export const updateTaskApi = async (payload) => {
  const res = await axiosInstance.put(
    `${Base_URL}/update`,
    payload,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteActionApi = async ({ taskId, actionUuid }) => {
  const res = await axiosInstance.delete(
    `${Base_URL}/${taskId}/action/${actionUuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteTaskApi = async (taskId) => {
  const res = await axiosInstance.delete(
    `${Base_URL}/${taskId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const getTeamMemberTasks = async () => {
  const res = await axiosInstance.get(
    `${Base_URL}/team-member`,
    getAuthHeaders(),
  );
  return res.data;
};

export const getDashboardSummaryApi = async () => {
  const res = await axiosInstance.get(`${Base_URL}/summary`, getAuthHeaders());
  return res.data;
};